var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"fullscreen":""},model:{value:(_vm.fullImageDialog),callback:function ($$v) {_vm.fullImageDialog=$$v},expression:"fullImageDialog"}},[_c('v-card',[_c('v-img',{attrs:{"src":_vm.chosenAdvert.image,"width":"100%","height":"100%","contain":""},on:{"click":_vm.closeDialog}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }